import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { map } from "rxjs";
import { StockPostingService } from "../services/stock-posting.service";

export const stockPostingGuard: CanActivateFn = () => {
  const stockService = inject(StockPostingService);
  const router = inject(Router);

  return stockService.loadOnly$().pipe(
    map((stockPosting) => {
      if (!stockPosting?.id) {
        return router.createUrlTree(['/mde-stockposting/select-lager']);
      }
      return true;
    })
  );
};
